const clone = obj => {
    if (obj) {
        return JSON.parse(JSON.stringify(obj))
    }
    return ''
};
// sessionStorage
const ssSet = (key, value) => sessionStorage.setItem(key, value);
const ssGet = key => sessionStorage.getItem(key);
const ssRemove = key => sessionStorage.removeItem(key);
// localStorage
const lcSet = (key, value) => localStorage.setItem(key, value);
const lcGet = key => localStorage.getItem(key);
const lcRemove = key => localStorage.removeItem(key);

const view_is_edit = value => {
    ssSet('view_is_edit', value)
}

const calc_time = (time) => {
    let now = time ? new Date(time) : new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return {
        time1: `${year}-${month}-${day}`,
        time2: `${hours}:${minutes}`,
        time3: `${year}-${month}-${day} ${hours}:${minutes}`,
        time4: `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`,
    }
}


export {
    clone,
    ssSet,
    ssGet,
    ssRemove,
    lcSet,
    lcGet,
    lcRemove,
    view_is_edit,
    calc_time
};
